import sortBy from 'lodash/sortBy';
import YPAttachmentObject from '../yesplan_classes/YPAttachmentObject';
import YPContactBooking from '../yesplan_classes/YPContactBookingObject';
import YPEventScheduleObject from '../yesplan_classes/YPEventScheduleObject';
import YPGeneratedReportObject from '../yesplan_classes/YPGeneratedReportObject';
import YPResourcBookingObject from '../yesplan_classes/YPResourceBookingObject';
import YPEventGroupObject from '../yesplan_classes/YPEventGroupObject';
import YPEventObject from '../yesplan_classes/YPEventObject';
import YPTimesheetObject from '../yesplan_classes/YPTimesheetObject';

export const formatAttachment = (attachmentJSON) =>
  new YPAttachmentObject(attachmentJSON);
export const formatContactBooking = (bookingJSON) => new YPContactBooking(bookingJSON);
export const formatEventSchedules = (schedulesJSON) =>
  new YPEventScheduleObject(schedulesJSON);
export const formatGeneratedReport = (generatedReport) =>
  new YPGeneratedReportObject(generatedReport);
export const formatResourceBooking = (resourceBookingJSON) =>
  new YPResourcBookingObject(resourceBookingJSON);

export const sortContactBookingsOnName = (bookings) =>
  sortBy(bookings, [(booking) => booking.name.toUpperCase()]);

export const groupAndSortGeneratedReports = (reports) => {
  const reportsPerTemplate = {};
  reports.forEach((report) => {
    const { templateId } = report;
    if (reportsPerTemplate[templateId]) reportsPerTemplate[templateId].push(report);
    else reportsPerTemplate[templateId] = [report];
  });

  return Object.keys(reportsPerTemplate).map((templateId) =>
    reportsPerTemplate[templateId].sort((report1, report2) =>
      report2.created.diff(report1.created)
    )
  );
};

export const categorizeBookingsPerGroup = (resourceBookings) => {
  const bookingsPerGroup = {};
  resourceBookings.forEach((booking) => {
    const groupKey = booking.resourceGroup;
    if (bookingsPerGroup[groupKey]) bookingsPerGroup[groupKey].push(booking);
    else bookingsPerGroup[groupKey] = [booking];
  });
  return bookingsPerGroup;
};

export const formatEventOrEventGroup = (eventOrGroupJSON) => {
  // eslint-disable-next-line no-underscore-dangle
  if (eventOrGroupJSON._type === 'group') return new YPEventGroupObject(eventOrGroupJSON);
  return new YPEventObject(eventOrGroupJSON);
};

/* event filter options */
function objectMap(obj, fn) {
  return Object.fromEntries(Object.entries(obj).map(([k, v], i) => [k, fn(v, k, i)]));
}

export const reformatRejectedCallsOutOfFilterOptions = (filterOptions) =>
  objectMap(filterOptions, (e) => (e.status && e.status === 'rejected' ? [] : e));

export const formatTimesheet = (timesheetJSON, dateString) =>
  new YPTimesheetObject(dateString, timesheetJSON);
export const formatTimesheets = (timesheetsJSON) => {
  const timesheetPerDay = {};
  Object.entries(timesheetsJSON).forEach(([dateString, timesheetJSON]) => {
    timesheetPerDay[dateString] = new YPTimesheetObject(dateString, timesheetJSON);
  });
  return timesheetPerDay;
};
